import { render, staticRenderFns } from "./FilterTable.vue?vue&type=template&id=12039c88&"
import script from "./FilterTable.vue?vue&type=script&lang=js&"
export * from "./FilterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports